import { render, staticRenderFns } from "./CreateMaterialRequestView.vue?vue&type=template&id=96f8c196&scoped=true&"
import script from "./CreateMaterialRequestView.vue?vue&type=script&lang=ts&"
export * from "./CreateMaterialRequestView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f8c196",
  null
  
)

export default component.exports